<template>
    <div class="publicacao-wrapper">
        <Toast />
        <div class="publicacao-header">
            <h2>Publicação</h2>
            <StatusLandingPage />
        </div>
        <div class="publicacao-container">
            <div class="secao">
                <div class="titulo-secao">URL Personalizada</div>
                <div class="p-inputgroup">
                    <InputText
                        v-model="urlPersonalizada"
                        placeholder="nome-evento"
                        @input="validarSlug"
                        :class="{ 'p-invalid': urlInvalida || !urlDisponivel }"
                        class="input-url"
                    />
                    <span v-if="verificandoUrl" class="p-inputgroup-addon">
                        <i class="pi pi-spin pi-spinner"></i>
                    </span>
                </div>
                <small v-if="urlInvalida" class="p-error">A URL deve conter apenas letras minúsculas, números e hífens.</small>
                <small v-if="!urlDisponivel && !urlInvalida" class="p-error">Esta URL já está em uso. Por favor, escolha outra.</small>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, defineExpose } from 'vue';
import { useStore } from 'vuex';
import { debounce } from 'lodash';
import InputText from 'primevue/inputtext';
import StatusLandingPage from './StatusLandingPage.vue';
import services from '@/app/checkins/eventos/services';
import { tryCatch } from '@/utils/tryCatch';
import Toast from 'primevue/toast';

const store = useStore();
const NOME_MODULO_VUEX = 'landingPage';

const urlPersonalizada = ref('');

const urlInvalida = ref(false);
const urlDisponivel = ref(true);
const verificandoUrl = ref(false);

onMounted(() => {
    const metadados = store.state[NOME_MODULO_VUEX].metadadosPagina;
    urlPersonalizada.value = metadados.urlPersonalizada || '';
});

const validarSlug = () => {
    const slugRegex = /^[a-z0-9-]+$/;
    urlInvalida.value = urlPersonalizada.value !== '' && !slugRegex.test(urlPersonalizada.value);
    urlDisponivel.value = true;

    if (urlPersonalizada.value === '') {
        verificandoUrl.value = false;
        return;
    }

    if (!urlInvalida.value) {
        salvarNoStore('urlPersonalizada', urlPersonalizada.value);
        debouncedVerificarUrl(urlPersonalizada.value);
    }
};

const debouncedVerificarUrl = debounce(async (url) => {
    if (!url) return;
    verificandoUrl.value = true;

    const { data, error } = await tryCatch(services.verificarUrlLandingPage(url));
    verificandoUrl.value = false;

    if (error) {
        console.error('Erro ao verificar URL:', error);
        urlDisponivel.value = false;
    } else {
        urlDisponivel.value = data?.disponivel !== false;
    }
}, 500);

const salvarNoStore = (chave, valor) => {
    store.dispatch(`${NOME_MODULO_VUEX}/atualizarMetadadosPorChave`, {
        chave: chave,
        valor: valor,
    });
};

const validarFormulario = async () => {
    validarSlug();
    if (debouncedVerificarUrl.flush) {
        await debouncedVerificarUrl.flush();
    }

    return !urlInvalida.value && urlDisponivel.value;
};

defineExpose({
    validarFormulario,
});
</script>

<style scoped>
.publicacao-wrapper {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    height: 100%;
    background-color: #ffffff;
}

.publicacao-header {
    padding: 16px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.publicacao-header h2 {
    font-size: 20px;
    color: #333;
    margin: 0;
    font-weight: 500;
}

.publicacao-container {
    padding: 20px;
    flex: 1;
}

.secao {
    margin-bottom: 24px;
}

.titulo-secao {
    font-weight: 600;
    font-size: 16px;
    margin-bottom: 10px;
    color: #333333;
}

.input-url {
    width: 100%;
    border-radius: 4px;
}

.datas-container {
    display: flex;
    gap: 20px;
}

.campo-data {
    flex: 1;
}

:deep(.p-calendar) {
    width: 100%;
}

:deep(.p-dropdown) {
    width: 100%;
}

:deep(.p-calendar .p-inputtext) {
    width: 100%;
}

:deep(.p-inputtext) {
    width: 100%;
}

:deep(.p-button.p-calendar-button) {
    background-color: #f8f9fa;
    border-color: #ced4da;
    color: #495057;
}

.p-error {
    color: #ff5757;
    font-size: 12px;
    margin-top: 4px;
    display: block;
}

@media (max-width: 768px) {
    .datas-container {
        flex-direction: column;
        gap: 16px;
    }
}
</style>
